import {Discount, Order, ProductQuantity} from "@/types";
import { AxiosInstance } from "axios";

export class DiscountApi {
  constructor(private axios: AxiosInstance) {}

  get(codes: string[], productQuantity: ProductQuantity[], deliveryPrice?: number, saleId?: number, newCode?: string): Promise<Discount[] | false> {
    return this.axios
      .put<Discount[] | false>("/discount", { codes, productQuantity, deliveryPrice, saleId, newCode })
      .then((r) => r.data);
  }

  apply(reservationId: number, discount: Discount): Promise<Order> {
    return this.axios
      .put<{ order: Order }>(
        `/reservations/${reservationId}/discount`,
        discount
      )
      .then((r) => r.data.order);
  }
}
